import React from 'react'
import VoiceTalent from './../VoiceTalent'

const VoiceTalentList = ({ roster }) => {
  return Object.entries(roster).map(([id, list]) => (
    <React.Fragment>
      <h2 key={id} className="text-gray-500 text-xs font-medium uppercase tracking-wide">
        { id }
      </h2>

      <ul className="mt-3 grid grid-cols-1 gap-5 sm:gap-6 sm:grid-cols-2 lg:grid-cols-4">
        { list.map((talent) => (
          <VoiceTalent key={talent.uid} {...talent} />
        )) }
      </ul>
    </React.Fragment>
  ))
}

export default VoiceTalentList
